import { atom } from "jotai";
import { fetchBase } from "./BaseApi";
import { State } from "./State";
import { MisaBrand } from "../pages/misa-top/MisaTypes";

const uri = "api/users/investment-brands";

export type FetchUserInvestmentBrandsParam = {
  pointOwnerId?: number;
};

export const fetchUserInvestmentBrandsAtom = atom<State<MisaBrand> | null>(null);

export const fetchUserInvestmentBrands = () => {
  return fetchBase<MisaBrand, FetchUserInvestmentBrandsParam>(
    uri,
    fetchUserInvestmentBrandsAtom
  );
};
